import React, { useState, useEffect } from 'react'

import {
    MenuItem,
    Select,
    TableSortLabel,
    InputLabel,
    TextField,
    Checkbox,
    ListItemIcon,
    ListItemText,
    Grid,
    Button,
    Input,
    SvgIcon,
} from "@material-ui/core";
import {
    handleSort,
} from "../utils/varialbles";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import http from "../services/httpService";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import { toast } from 'react-hot-toast';
import filterData from '../components/filterCriteria';
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";


// import './../index.css'
const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    table: {
        field: "Resizing",
        title: "Column Width",
        cellStyle: {
            whiteSpace: "nowrap",
            width: "20%",
        },
    },
    tableRow: {
        "&:hover": {
            cursor: "pointer",
        },
    },
    indeterminateColor: {
        color: "#f50057",
    },
    selectAllText: {
        fontWeight: 500,
    },
    selectedAll: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
        },
    },
    radio: {
        "&$checked": {
            color: "#57bf74",
        },
    },
    checked: {},
});



const columns = [
    //{ label: 'User Id', id: 'UserID', minWidth: 150 },
    { headerName: "Name", id: "name", show: true, minWidth: 150, },
    { headerName: "Role", id: "role", show: true, minWidth: 150, },
    { headerName: "Prospects", id: "prospects", show: true, minWidth: 150, },
    { headerName: "Investors", id: "investors", show: true, minWidth: 150, },
    { headerName: "Revenue", id: "revenue", show: true, minWidth: 150, },
];

export default function FranchiseDashboard() {
    const classes = useStyles();
    const [franhchiseDatas, setFranchiseDatas] = useState({
        prospects: 0,
        amount: 0,
        investors: 0
    });
    const [counters, setCounters] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = React.useState(0);
    const [appliedFilter, setAppliedFilter] = useState([]);
    const [isFilterData, setIsFilterData] = useState([]);
    const [isRange, setIsRange] = React.useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [orignalRows, setOriginalRows] = useState([]);
    const [filterTrue, setFilterTrue] = useState(false);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [isFilterString, setIsFilterString] = useState('');
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("");

    // role based permissions

    const [isSelectedData, setIsSelectedDatas] = useState(
        (localStorage.getItem("empRole") === "MF Manager") ?
            [
                {
                    id: 1,
                    options: [],
                    name: "Franchise",
                },
                {
                    id: 2,
                    options: [],
                    name: "Agents",
                },
                {
                    id: 3,
                    data: { equalTo: "" },
                    name: "Signup Date",
                },
            ] :
            (localStorage.getItem("empRole") === "MF Executive") ? [
                {
                    id: 1,
                    data: { equalTo: "" },
                    name: "Signup Date",

                },
            ] :
                (
                    localStorage.getItem("empRole") === "Franchise"
                ) ?
                    [
                        {
                            id: 1,
                            options: [],
                            name: "Agents",
                        },
                        {
                            id: 2,
                            data: { equalTo: "" },
                            name: "Signup Date",

                        },
                    ]
                    :
                    [
                        {
                            id: 1,
                            options: [],
                            name: "Master Franchise"
                        },
                        {
                            id: 2,
                            options: [],
                            name: "Franchise",
                        },
                        {
                            id: 3,
                            options: [],
                            name: "Agents",
                        },
                        {
                            id: 4,
                            data: { equalTo: "" },
                            name: "Signup Date",
                        },

                    ]

    )

    // calling the API's
    useEffect(() => {
        setCounters(counters + 1)
        if (filterTrue === true) {
            setIsFilterString(getFilterParams());
        }
        let filtermatchString = getFilterParams();
        if (counters >= 2) {
            if (filtermatchString === isFilterString) {
                getFranchiseDashboardData()
            }
        }
    }, [isFilterString,
        , appliedFilter,

    ]);
    useEffect(() => {
        getFranchiseDashboardData()
    }, []);

    // get api function 
    const getFranchiseDashboardData = (newQuery) => {
        toast.loading("Please wait...");
        const baseURL = '/franchise_master';
        http.get(getPaginationURL(baseURL, newQuery) + isFilterString)
            .then((response) => {
                toast.dismiss();
                if (response.data.statusCode === 0) {
                    setFranchiseDatas({
                        ...franhchiseDatas,
                        prospects: response.data.data.prospects,
                        investors: response.data.data.investors,
                        amount: response.data.data.amount,
                    })
                    if (response.data.filter.length > 0) {
                        let rawData = response.data.filter.map((es, index) => {
                            es.id = index + 1;
                            return es;
                        });
                        setIsFilterData(rawData);
                        if (response.data.list_data !== undefined && response.data.list_data.length !== 0) {
                            setOriginalRows(response.data.list_data);
                            setTotalRowCount(response.data.list_data.length)
                        }
                        else {
                            setOriginalRows([])
                        }
                    }
                    else {
                        setIsFilterData([])
                    }
                }

            }
            ).catch((error) => {
            })
    }

    const getPaginationURL = (url, newQuery) => {
        const query = newQuery === "" ? newQuery : "";
        if (query) {
            return `${url}?page=${page + 1
                }&rowsPerPage=${rowsPerPage}&search=${query}`;
        } else {
            return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
        }
    };

    const handleSelectChange = (v, id, meta, event) => {
        if (v === "range") {
            setIsRange(true);
        } else {
            // setIsRange(false);
        }
        if (meta === "Master Franchise" || meta === "Franchise") {
            updateAgentsDropdown(v)

        }
        // if (meta === "Master Franchise") {
        //     updateFranchiseDropdown(v, id, event)
        // }
        // if (meta === "Franchise") {
        //     updateAgentsDropdown(v, id)
        // }
        setIsSelectedDatas((fstate) => {
            const newState = isFilterData.map((x) => {
                if (x.id === id) {
                    //check the type and add value according to the value.
                    // if(x.type === 'number'){
                    //     return ({
                    //         name: x.name,
                    //         id: x.id,
                    //         value: parseFloat(v),
                    //         // options: v
                    //     })
                    // }
                    if (x.type === "select") {
                        return {
                            name: x.name,
                            id: x.id,
                            options: v,
                        };
                    }
                    else if (x.type === "radio") {
                        return {
                            name: x.name,
                            id: x.id,
                            options: [v],
                        };
                    }
                    else if (x.type === "date" || x.type === "number") {
                        if (meta === "option") {
                            const fstateObject = fstate.find((filter) => filter.id === x.id);
                            let currentValue = fstateObject.data.lessThan
                                ? fstateObject.data.lessThan
                                : "";
                            currentValue = fstateObject.data.greaterThan
                                ? fstateObject.data.greaterThan
                                : "";
                            currentValue = fstateObject.data.equalTo
                                ? fstateObject.data.equalTo
                                : "";
                            currentValue = fstateObject.data.greaterThanEqual
                                ? fstateObject.data.greaterThanEqual
                                : "";
                            currentValue = fstateObject.data.lessThanEqual
                                ? fstateObject.data.lessThanEqual
                                : "";
                            currentValue = fstateObject.data.range
                                ? fstateObject.data.range
                                : "";
                            // (currentValue);
                            return { id, name: x.name, data: { [v]: currentValue } };
                        }
                        else if (meta === "value") {
                            const fstateObject = fstate.find((filter) => filter.id === x.id);
                            const currentOption = Object.keys(fstateObject.data)[0];
                            return { id, name: x.name, data: { [currentOption]: v } };
                        }
                        else if (meta === "rangeFrom") {
                            const fstateObject = fstate.find((filter) => filter.id === x.id);
                            const currentOption = Object.keys(fstateObject.data)[0];
                            const currentValue =
                                fstateObject.data[Object.keys(fstateObject.data)[0]];
                            if (currentValue.includes(",")) {
                                const fromValue = currentValue.split(",")[0];
                                const toValue = currentValue.split(",")[1];
                                const encodedDate = `${v},${toValue}`;
                                // ({currentValue, v, fromValue, toValue, encodedDate});
                                return {
                                    id,
                                    name: x.name,
                                    data: { [currentOption]: encodedDate },
                                };
                            }
                            else {
                                const encodedDate = `${v},`;
                                // (currentValue, v, encodedDate)
                                return {
                                    id,
                                    name: x.name,
                                    data: { [currentOption]: encodedDate },
                                };
                            }
                        }
                        else if (meta === "rangeTo") {
                            const fstateObject = fstate.find((filter) => filter.id === x.id);
                            const currentOption = Object.keys(fstateObject.data)[0];
                            const currentValue =
                                fstateObject.data[Object.keys(fstateObject.data)[0]];
                            if (currentValue.includes(",")) {
                                const fromValue = currentValue.split(",")[0];
                                const toValue = currentValue.split(",")[1];
                                const encodedDate = `${fromValue},${v}`;
                                // ({currentValue, v, fromValue, toValue, encodedDate});
                                return {
                                    id,
                                    name: x.name,
                                    data: { [currentOption]: encodedDate },
                                };
                            }
                            else {
                                const encodedDate = `,${v}`;
                                // (currentValue, v, encodedDate)
                                return {
                                    id,
                                    name: x.name,
                                    data: { [currentOption]: encodedDate },
                                };
                            }
                        }
                    }
                } else {
                    return fstate.find((filter) => filter.id === x.id);
                }
            });
            return newState;
        });

    };
    const openFilter = (e) => {
        setIsFilterOpen(true);
    };
    const shouldNameDisplay = (filter) => {
        return filter.showName ? filter.name : "";
    };
    const closeFilter = () => {
        setIsFilterOpen(false);
    };
    const handleRequestSort = (e, property, format) => {
        let isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        let tempRows = [...orignalRows];
        let finalRows = handleSort(property, format, tempRows, isAsc);
        setOriginalRows(finalRows);
        setPage(0);
    };

    const updateFranchiseDropdown = (v, id) => {
        const incrementId = id + 1;
        isSelectedData.forEach(selectedData => {
            selectedData.options = [];
            updateAgentsDropdown(selectedData.options, 2)
            isFilterData.forEach(filterData => {
                if (filterData.options !== undefined) {
                    if (filterData.options.length !== 0) {
                        filterData.options
                            .filter(option => v.includes(option.Franchise_value))
                            .forEach(validOption => {
                                selectedData.options.push(validOption.value);
                                updateAgentsDropdown(selectedData.options, 2)
                            });
                    }
                }
            });
            // if (selectedData && selectedData.id === incrementId) {

            // }
        });
    };

    const updateAgentsDropdown = (v, id) => {
        // const incrementId = id + 1;
        isSelectedData.forEach(selectedData => {
            // ('ewzdx');
            if (localStorage.getItem('empRole') === "MF Manager") {
                // ('ewzdxghss');
                if (selectedData && selectedData.id === 2) {
                    selectedData.options = [];
                    isFilterData.forEach(filterData => {
                        if (filterData.options !== undefined) {
                            if (filterData.options.length !== 0) {
                                filterData.options
                                    .filter(option =>
                                        v.includes(option.Franchise_value))
                                    .forEach(validOption => {
                                        selectedData.options.push(validOption.value);
                                        // (validOption.value, 'Szdfg');
                                    });

                            }
                        }
                    })
                }
            }
            else {
                // ('ewzdxgh');
                if (selectedData && selectedData.id === 2) {
                    selectedData.options = [];
                    isFilterData.forEach(filterData => {
                        if (filterData.options !== undefined) {
                            if (filterData.options.length !== 0) {
                                filterData.options
                                    .filter(option =>
                                        v.includes(option.mf_value))
                                    .forEach(validOption => {
                                        selectedData.options.push(validOption.value);
                                        // (validOption.value, 'Szdfg');
                                    });

                            }
                        }
                    })
                }
            }

            if (selectedData && selectedData.id === 3) {
                selectedData.options = [];
                // (v, 'rtrcgh');
                isFilterData.forEach(filterData => {
                    if (filterData.options !== undefined) {
                        if (filterData.options.length !== 0) {
                            filterData.options
                                .filter(option =>
                                    v.includes(option.Franchise_value))
                                .forEach(validOption => {
                                    selectedData.options.push(validOption.value);
                                });

                        }
                    }
                })
            }
        })
    }

    const getFilterParams = () => {
        const conversionFormatFor_select = {
            "Master Franchise": "mfs",
            "Franchise": "fs",
            "Agents": 'agents'
        };
        const conversionFormatFor_date = {
            "Signup Date": "signup",
        };
        const filterParams = {};

        appliedFilter.map((filter) => {
            if (filter.options) {
                // condition it based on type of filter rather than options or data props

                filterParams[conversionFormatFor_select[filter.name]] = filter.options
                    .map((x) => x)
                    .join(",");
            } else if (filter.data) {
                let suffix;
                if (Object.keys(filter.data)[0] === "greaterThan") {
                    suffix = "gt";
                } else if (Object.keys(filter.data)[0] === "lessThan") {
                    suffix = "lt";
                } else if (Object.keys(filter.data)[0] === "equalTo") {
                    suffix = "date";
                } else if (Object.keys(filter.data)[0] === "lessThanEqual") {
                    suffix = "date__lte";
                } else if (Object.keys(filter.data)[0] === "greaterThanEqual") {
                    suffix = "gte";
                } else if (Object.keys(filter.data)[0] === "range") {
                    suffix = "date__range";
                }

                filterParams[conversionFormatFor_date[filter.name] + suffix] =
                    filter.data[Object.keys(filter.data)[0]];
            }
            // else if(filter.value){
            //     filterParams[conversionFormatFor_number[filter.name]] = filter.value;
            // }
        });
        //return the query string with the filterParams
        const params = Object.keys(filterParams)
            .map((x) => x + "=" + filterParams[x])
            .join("&");
        return params ? "&" + params : "";
    };
    const parseRangeValue = (doubleDate, fromTo) => {
        if (fromTo === "from") {
            return doubleDate.split(",")[0];
        } else {
            return doubleDate.split(",")[1];
        }
    };
    const applyFilters = () => {
        setFilterTrue(true);
        const cleanedFilterState = isSelectedData.filter((x) => {
            if (x.options) {
                // for select and radios
                return x.options.length > 0;
            } else if (x.data) {
                // for date
                return (
                    x.data.greaterThan ||
                    x.data.lessThan ||
                    x.data.equalTo ||
                    x.data.lessThanEqual ||
                    x.data.greaterThanEqual ||
                    x.data.range
                );
            } else if (x.value) {
                // for number type
                //x.value is a number u cant get length of it
                return x.value.toString().length > 0;
            }
            // (x);
        });

        // localStorage.setItem("prospectFilter", JSON.stringify(cleanedFilterState));

        setAppliedFilter(cleanedFilterState);
        if (appliedFilter !== 0) {
            appliedFilter.map((x) => {
                if (x.type === "select" || x.type === "radio") {
                    const selectFilerobject = {
                        id: x.id,
                        options: [x.options],
                        name: x.name,
                    };
                    isSelectedData.push(selectFilerobject);
                } else if (x.type === "date" || x.type === "number") {
                    // var today = new Date();
                    const emptyFilterObject = {
                        id: x.id,
                        data: {
                            equalTo: "",
                        },
                        name: x.name,
                    };
                    isSelectedData.push(emptyFilterObject);
                }
            });
        }
        setIsFilterString(getFilterParams());

        // ("filter");
        // props.setOpen(false);
        setIsFilterOpen(false);
        // getData()
    };
    const clearFilters = () => {
        setIsSelectedDatas(
            (localStorage.getItem("empRole") === "MF Manager") ?
                [
                    {
                        id: 1,
                        options: [],
                        name: "Franchise",
                    },
                    {
                        id: 2,
                        options: [],
                        name: "Agents",
                    },
                    {
                        id: 3,
                        data: { equalTo: "" },
                        name: "Signup Date",
                    },
                ] :
                (localStorage.getItem("empRole") === "MF Executive") ? [
                    {
                        id: 1,
                        data: { equalTo: "" },
                        name: "Signup Date",

                    },
                ] :
                    (
                        localStorage.getItem("empRole") === "Franchise"
                    ) ?
                        [
                            {
                                id: 1,
                                options: [],
                                name: "Agents",
                            },
                            {
                                id: 2,
                                data: { equalTo: "" },
                                name: "Signup Date",

                            },
                        ]
                        :
                        [
                            {
                                id: 1,
                                options: [],
                                name: "Master Franchise"
                            },
                            {
                                id: 2,
                                options: [],
                                name: "Franchise",
                            },
                            {
                                id: 3,
                                options: [],
                                name: "Agents",
                            },
                            {
                                id: 4,
                                data: { equalTo: "" },
                                name: "Signup Date",
                            },

                        ]
        )
        // setOriginalRows([]);
        setIsFilterString("");
    }
    // (isSelectedData, 'isSelectedData');

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    let curr = new Date();
    curr.setDate(curr.getDate());
    let getCurrentdate = curr.toISOString().substring(0, 10);
    return (
        <div>
            {/* franchiseDashboard */}
            <div
                style={{
                    display: "flex",
                    position: "relative",
                    // width: "max-content",
                    justifyContent: 'flex-end'
                }}
                className="tfilter"
            >
                <div>
                    <span style={{ margin: "0px 15px" }}>
                        Filter
                        <SvgIcon
                            style={{
                                cursor: "pointer",
                                verticalAlign: "middle",
                                marginLeft: "10px",
                            }}
                            onClick={openFilter}
                            title={"filter"}
                        >
                            <FilterLogo />
                        </SvgIcon>
                    </span>
                    {/* <Filter data={passData} setOpen={handleMenuClose} isMenuOpen={isMenuOpen} style={{ border: '3px solid black' }} /> */}
                    {isFilterOpen ? (
                        <div
                            className={["newfilterstyle", "menupopupfilter", "filter"].join(
                                " "
                            )}
                        >
                            {/* {('am fun', isSelectedData)} */}
                            <div
                                style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    lineHeight: "30px",
                                    display: "flex",
                                    justifyContent: "center",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    background: "#ddd",
                                    margin: "5px 0 0 5px",
                                }}
                                onClick={closeFilter}
                            >
                                X
                            </div>

                            {isFilterData.map((filter, index) => {
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            marginLeft: 20,
                                            paddingBottom: 10,
                                            paddingTop: 10,
                                        }}
                                    >
                                        <div>
                                            <InputLabel style={{ color: "black" }}>
                                                {shouldNameDisplay(filter)}
                                            </InputLabel>

                                        </div>

                                        <div style={{ paddingTop: 10 }}>
                                            {filter.type === "select" ? (
                                                <>
                                                    <Select
                                                        labelId="mutiple-select-label"
                                                        displayEmpty
                                                        className="select"
                                                        variant="outlined"
                                                        multiple
                                                        style={{ paddingLeft: "5px" }}
                                                        value={
                                                            isSelectedData.find((x) => {
                                                                return x.id === filter.id;
                                                            })?.options || []
                                                        }
                                                        name={filter.name}
                                                        onChange={(e) => {
                                                            handleSelectChange(e.target.value, filter.id, filter.name);
                                                        }}
                                                        // renderValue={(selectedDatas) => selectedDatas.join(", ")}
                                                        renderValue={(selected) => {
                                                            return selected
                                                                .map(
                                                                    (s) =>
                                                                        filter.options.find((x) => x.value === s)
                                                                            ?.name
                                                                )
                                                                .join(", ");
                                                        }}

                                                    // MenuProps={MenuProps}
                                                    >
                                                        {filter.options.map((option, index) => (
                                                            <MenuItem key={index} value={option.value}>
                                                                <ListItemText primary={option.name} />
                                                                <ListItemIcon>
                                                                    <Checkbox
                                                                        classes={{
                                                                            root: classes.radio,
                                                                            checked: classes.checked,
                                                                        }}
                                                                        checked={
                                                                            isSelectedData
                                                                                .find((x) => x.id === filter.id)
                                                                                ?.options.indexOf(option.value) !== -1
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        style={{ paddingLeft: "5px" }}
                                                                    />
                                                                </ListItemIcon>
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </>
                                            ) : filter.type === "radio" ? (
                                                <>
                                                    <Select
                                                        displayEmpty
                                                        value={
                                                            isSelectedData.find((x) => {
                                                                return x.id === filter.id;
                                                            })?.options
                                                        }
                                                        onChange={(e) => {
                                                            handleSelectChange(e.target.value, filter.id);
                                                        }}
                                                        name={filter.name}
                                                        className="select"
                                                        variant="outlined"
                                                        multiple
                                                        style={{
                                                            backgroundColor: "white",
                                                        }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        {filter.options.map((option, index) => {
                                                            return (
                                                                <MenuItem key={index} value={option.value}>
                                                                    <ListItemText primary={option.name} />
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </Select>
                                                </>
                                            ) : filter.type === "date" ? (
                                                <>
                                                    <>
                                                        {/* <label
                                                            style={{
                                                                fontSize: 11,
                                                                marginBorrom: 10,
                                                                display: "block",
                                                            }}
                                                        >
                                                            {" "}
                                                            From{" "}
                                                        </label> */}
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            max={getCurrentdate}
                                                            style={{
                                                                borderColor: "rgba(0, 0, 0, 0.23)"
                                                            }}
                                                            value={parseRangeValue(
                                                                isSelectedData.find(
                                                                    (x) => x.id === filter.id
                                                                )?.data[
                                                                Object.keys(
                                                                    isSelectedData.find(
                                                                        (x) => x.id === filter.id
                                                                    )?.data || {}
                                                                )[0]
                                                                ],
                                                                "from"
                                                            )}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            inputProps={{
                                                                // min: "2020-08-10",
                                                                max: getCurrentdate
                                                            }}

                                                            onChange={(x) =>
                                                                handleSelectChange(
                                                                    x.target.value,
                                                                    filter.id,
                                                                    "rangeFrom"
                                                                )
                                                            }
                                                            className="select"

                                                        />
                                                        {/* <label
                                                            style={{
                                                                fontSize: 11,
                                                                marginBorrom: 10,
                                                                display: "block",
                                                            }}
                                                        >
                                                            {" "}
                                                            To{" "}
                                                        </label> */}
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            max={getCurrentdate}
                                                            value={parseRangeValue(
                                                                isSelectedData.find(
                                                                    (x) => x.id === filter.id
                                                                )?.data[
                                                                Object.keys(
                                                                    isSelectedData.find(
                                                                        (x) => x.id === filter.id
                                                                    )?.data || {}
                                                                )[0]
                                                                ],
                                                                "to"
                                                            )}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            inputProps={{
                                                                // min: "2020-08-10",
                                                                max: getCurrentdate
                                                            }}
                                                            onChange={(x) =>
                                                                handleSelectChange(
                                                                    x.target.value,
                                                                    filter.id,
                                                                    "rangeTo"
                                                                )
                                                            }
                                                            className="select"
                                                            style={{
                                                                backgroundColor: "white",
                                                                marginTop: '10px',
                                                                borderColor: "rgba(0, 0, 0, 0.23)"

                                                            }}
                                                        />
                                                    </>

                                                </>
                                            ) : filter.type === "number" ? (
                                                <>
                                                    <select
                                                        value={
                                                            Object.keys(
                                                                isSelectedData.find((x) => {
                                                                    return x.id === filter.id;
                                                                })?.data || {}
                                                            )[0]
                                                        }
                                                        onChange={(x) =>
                                                            handleSelectChange(
                                                                x.target.value,
                                                                filter.id,
                                                                "option"
                                                            )
                                                        }
                                                        className="select"
                                                        label={filter.name}
                                                        style={{
                                                            backgroundColor: "white",
                                                            marginBottom: 10,
                                                        }}
                                                    >
                                                        <option value={"equalTo"}>Equal To</option>
                                                        <option value={"lessThan"}>Less Than</option>
                                                        <option value={"greaterThan"}>
                                                            Greater Than
                                                        </option>
                                                        <option value={"lessThanEqual"}>
                                                            Less Than Equal To
                                                        </option>
                                                        <option value={"greaterThanEqual"}>
                                                            Greater Than Equal To
                                                        </option>
                                                        <option value={"range"}>Range</option>
                                                    </select>

                                                    {Object.keys(
                                                        isSelectedData.find((x) => {
                                                            return x.id === filter.id;
                                                        })?.data || {}
                                                    )[0] !== "range" ? (
                                                        <TextField
                                                            type="text"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            value={
                                                                isSelectedData.find((x) => x.id === filter.id)
                                                                    ?.data[
                                                                Object.keys(
                                                                    isSelectedData.find(
                                                                        (x) => x.id === filter.id
                                                                    )?.data || {}
                                                                )[0]
                                                                ]
                                                            }
                                                            onChange={(x) =>
                                                                handleSelectChange(
                                                                    x.target.value,
                                                                    filter.id,
                                                                    "value"
                                                                )
                                                            }
                                                            className="select"
                                                            style={{
                                                                backgroundColor: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        // RANGE FIELDS
                                                        <>
                                                            <label
                                                                style={{
                                                                    fontSize: 11,
                                                                    marginBorrom: 10,
                                                                    display: "block",
                                                                }}
                                                            >
                                                                {" "}
                                                                From{" "}
                                                            </label>
                                                            <TextField
                                                                type="text"
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                value={parseRangeValue(
                                                                    isSelectedData.find(
                                                                        (x) => x.id === filter.id
                                                                    )?.data[
                                                                    Object.keys(
                                                                        isSelectedData.find(
                                                                            (x) => x.id === filter.id
                                                                        )?.data || {}
                                                                    )[0]
                                                                    ],
                                                                    "from"
                                                                )}
                                                                onChange={(x) =>
                                                                    handleSelectChange(
                                                                        x.target.value,
                                                                        filter.id,
                                                                        "rangeFrom"
                                                                    )
                                                                }
                                                                className="select"
                                                                style={{
                                                                    backgroundColor: "white",
                                                                }}
                                                            />
                                                            <label
                                                                style={{
                                                                    fontSize: 11,
                                                                    marginBorrom: 10,
                                                                    display: "block",
                                                                }}
                                                            >
                                                                {" "}
                                                                To{" "}
                                                            </label>
                                                            <TextField
                                                                type="text"
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                value={parseRangeValue(
                                                                    isSelectedData.find(
                                                                        (x) => x.id === filter.id
                                                                    )?.data[
                                                                    Object.keys(
                                                                        isSelectedData.find(
                                                                            (x) => x.id === filter.id
                                                                        )?.data || {}
                                                                    )[0]
                                                                    ],
                                                                    "to"
                                                                )}
                                                                onChange={(x) =>
                                                                    handleSelectChange(
                                                                        x.target.value,
                                                                        filter.id,
                                                                        "rangeTo"
                                                                    )
                                                                }
                                                                className="select"
                                                                style={{
                                                                    backgroundColor: "white",
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                            <div
                                style={{
                                    float: "right",
                                    paddingBottom: 10,
                                    paddingRight: 40,
                                    paddingTop: 10,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    columnGap: 20,
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={clearFilters}
                                    color="default"
                                >
                                    Clear
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={applyFilters}
                                    color="primary"
                                >
                                    Apply
                                </Button>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>

            <div className='franchise_main'>
                <div className='franhise_child'>
                    <div>
                        <p>
                            Total Prospect
                        </p>
                    </div>
                    <div>
                        <h1>
                            {
                                franhchiseDatas.prospects
                            }
                        </h1>
                    </div>
                </div>
                <div className='franhise_child'>
                    <div>
                        <p>
                            Total Investors
                        </p>
                    </div>
                    <div>
                        <h1>
                            {
                                franhchiseDatas.investors

                            }
                        </h1>
                    </div>
                </div>
                <div className='franhise_child'>
                    <div>
                        <p>
                            Total Revenue
                        </p>
                    </div>
                    <div>
                        <h1>
                            &#8377;{
                                franhchiseDatas.amount !== null ? franhchiseDatas.amount.toLocaleString('en') : 0
                            }
                        </h1>
                    </div>
                </div>
            </div>
            {
                orignalRows.length !== 0 ? (
                    <>
                        <TableContainer className={classes.container}
                            style={{ marginTop: '15px' }}
                        >
                            <Table stickyHeader aria-label="sticky table" size="small"
                            >
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                                className='prospect_table'

                                            >
                                                <TableSortLabel
                                                    active={orderBy === column.id}
                                                    direction={orderBy === column.id ? order : "asc"}
                                                    onClick={(e) =>
                                                        handleRequestSort(e, column.id, column.format)
                                                    }
                                                >
                                                    {column.headerName}
                                                </TableSortLabel>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        orignalRows.length !== 0 ? (
                                            <>
                                                {orignalRows
                                                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={index + "a"}
                                                                className='prospecttable'

                                                            >
                                                                {columns.map((column, index) => {
                                                                    const value = row[column.id];
                                                                    return (
                                                                        <TableCell
                                                                            key={index + column.id}
                                                                            align={column.align}
                                                                        // onDoubleClick={() => viewProspectDetails(row)}
                                                                        >
                                                                            {column.format && typeof value === "number" ? (
                                                                                column.format(value)
                                                                            ) : column.id === "detailsButton" ? (
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    style={{ borderRadius: 20 }}
                                                                                // onClick={() => viewDetails(row)}
                                                                                >
                                                                                    View Details
                                                                                </Button>
                                                                            ) : column.format === "Date" ? (
                                                                                // getDate(value)""
                                                                                ""
                                                                            ) : column.operation &&
                                                                                column.operation === "concate" ? (
                                                                                value + column.operand + row[column.with]
                                                                            ) : column.type &&
                                                                                column.type === "link" &&
                                                                                value ? (
                                                                                <Link
                                                                                    variant="body2"
                                                                                    // onClick={(e) => viewDetails(row)}
                                                                                    // onClick={(e) => viewProspectDetails(row)}

                                                                                    gutterBottom
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    {value}
                                                                                </Link>
                                                                            ) : column.type &&
                                                                                column.type === "attach" &&
                                                                                value ? (
                                                                                <Link
                                                                                    // href={staticFiles + value}
                                                                                    target="_blank"
                                                                                    variant="body2"
                                                                                    gutterBottom
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    {value}
                                                                                </Link>
                                                                            ) : value === null ? (
                                                                                <div>N/A</div>
                                                                            ) : (
                                                                                value
                                                                            )}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                            </TableRow>
                                                        );
                                                    })}
                                            </>
                                        ) : (
                                            <TableCell colspan="7" style={{ "text-align": "center", margin: "10px 0px" }} >
                                                Records Not Available</TableCell>


                                        )
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div>
                            {/* <tab />   // Need To Comment This           */}
                            <TablePagination
                                rowsPerPageOptions={[10, 50, 100, 500]}
                                component="div"
                                count={totalRowCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            // style={{width:'27rem'}}
                            />
                        </div>
                    </>
                ) : ""
            }

        </div>
    )
}
